import { Animation } from '../components/animation'

export function servicesAnchor() {
    const animation = new Animation;

    const reg = /#block/;

    if (!reg.test(window.location.hash)) {
        return false;
    }

    let block = document.querySelector(window.location.hash),
        blockInner = block.querySelector('[am-inner-category="services-head"]'),
        blockBtn = block.querySelector('.js-servicesCategoryShow'),
        fixidHeight = document.querySelector('[am-fixed]').clientHeight,
        headerHeight = fixidHeight > 125 ? 101 : 95;

    animation.scroll(block, headerHeight, 0);

    blockInner.classList.add('is-active');

    if (!blockBtn) {
        return false;
    }

    blockBtn.classList.add('is-active');
    blockBtn.textContent = 'Скрыть подробности';
}